export default {"src":"/_next/static/media/alert-icon-on.c572f073.svg","height":24,"width":25};